<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      v-loading="listLoading"
                      width="100%"
                      height="100%">
                <el-table-column type="index" width="65" label="序号"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "tableView",
        data() {
            const showMaximum = (row, column, cellValue, index) => {
                let text = '';
                if(row.product_type === 1) {
                    text = `${row.per_score}分`
                } else if (row.product_type === 2) {
                    text = `规格1：${row.per_score1}分；规格2：${row.per_score2}分`
                }
                return text
            };
            return {
                searchForm: {
                    input: ''
                },

                tableData: [],
                columnData: [
                    {label: '产品名称', prop: 'product_name'},
                    {label: '产品代码', prop: 'product_code'},
                    {label: '产品ID', prop: 'drug_code'},
                    {label: '周期天数', prop: 'cycle_days'},
                    {label: '周期用药支数', prop: 'cycle_medication_count'},
                    {label: '周期最高分', prop: 'cycle_max_scores'},
                    {label: '每支分数', prop: 'score', formatter: showMaximum, width: 300},
                ],
                listLoading: false,
            }
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            ...mapMutations('manageData', {
                setJIFENSetData: 'setJIFENSetData'
            }),
            getTableData() {
                this.httpGet('/product/list').then(res => {
                    this.tableData = res.data.data_list;
                });
            },

            editRow(row) {
                this.setJIFENSetData(row);
                this.$emit('changeTopTab', 'addView')
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>